// extracted by mini-css-extract-plugin
export default {"label":"lCY21N"};